import { Injectable, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { Helpers } from "src/app/helpers";

@Injectable({
  providedIn: 'root'
})
export class NavigationMenuService {

  private HELP_URL = environment.cdnEndPoint + environment.helpUrl;
  private STUDYSTAT_HELP_URL = environment.cdnEndPoint + environment.studyStatHelpUrl;
  private RASPberryAI_HELP_URL = environment.cdnEndPoint + environment.raspberryAIHelpUrl;
  private PRIVACY_URL = environment.cdnEndPoint + environment.privacyUrl;
  private TERMS_URL = environment.cdnEndPoint + environment.termsUrl;
  private VERSION_URL = environment.cdnEndPoint + environment.cdnVersionPath;

  private visibleSubject = new BehaviorSubject(true);

  @Output() setupNavMenu: EventEmitter<boolean> = new EventEmitter();

  constructor(private http: HttpClient) { }

  hide() {
    this.visibleSubject.next(false);
  }

  show() {
    this.visibleSubject.next(true);
  }

  getNavigationVisibility() {
    return this.visibleSubject.asObservable();
  }

  setupNavigationMenu() {
    this.setupNavMenu.emit();
  }

  getPrivacy() {
    return new Promise<string>((resolve, reject) => {
      this.http.get<string>(this.PRIVACY_URL, { responseType: 'text' as 'json' }).toPromise().then((response?: string) => {
        if (response == null)
          response = "";
        resolve(response);
      }, (err) => {
        reject(err);
      });
    });
  }

  getTerms() {
    return new Promise<string>((resolve, reject) => {
      this.http.get<string>(this.TERMS_URL, { responseType: 'text' as 'json' }).toPromise().then((response?: string) => {
        if (response == null)
          response = "";
        resolve(response);
      }, (err) => {
        reject(err);
      });
    });
  }

  getHelp() {
    let url = this.HELP_URL + Helpers.getPlatformName().toLowerCase().replace(' ','') + "-help.html?v=" + new Date().toISOString();
    return new Promise<string>((resolve, reject) => {
      this.http.get<string>(url, { responseType: 'text' as 'json' }).toPromise().then((response?: string) => {
        if (response == null)
          response = "";
        resolve(response);
      }, (err) => {
        reject(err);
      });
    });

  }
  getStudyStatHelp() {
    let url = this.STUDYSTAT_HELP_URL + Helpers.getPlatformName().toLowerCase() + "-help.html?v=" + new Date().toISOString();
    return new Promise<string>((resolve, reject) => {
      this.http.get<string>(url, { responseType: 'text' as 'json' }).toPromise().then((response?: string) => {
        if (response == null)
          response = "";
        resolve(response);
      }, (err) => {
        reject(err);
      });
    });

  }
  getRASPberryAIHelp() {
    let url = this.RASPberryAI_HELP_URL + Helpers.getPlatformName().toLowerCase().replace(' ','') + "-help.html?v=" + new Date().toISOString();
    return new Promise<string>((resolve, reject) => {
      this.http.get<string>(url, { responseType: 'text' as 'json' }).toPromise().then((response?: string) => {
        if (response == null)
          response = "";
        resolve(response);
      }, (err) => {
        reject(err);
      });
    });

  }

  getContactDetails() {
    let url = this.HELP_URL + Helpers.getPlatformName().toLowerCase().replace(' ','') + "-contact.html?v=" + new Date().toISOString();
    return new Promise<string>((resolve, reject) => {
      this.http.get<string>(url, { responseType: 'text' as 'json' }).toPromise().then((response?: string) => {
        if (response == null)
          response = "";
        resolve(response);
      }, (err) => {
        reject(err);
      });
    });
  }

  getVersion(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.http.get<string>(this.VERSION_URL, { responseType: 'text' as 'json' }).toPromise().then((response?: string) => {
        if (response == null)
          response = "";
        resolve(response);
      }, (err) => {
        reject(err);
      });
    });
  }
}
